@let _sibCategories = siblingCategories();
@let _selectedCategoryName = currentCategoryName();

@if (_sibCategories?.length > 0) {
  <ul sd-list-inline class="c__sibling-categories is-xs" data-testid="list">
    @for (siblingCategory of _sibCategories; track siblingCategory?.code) {
      <li>
        <a sd-button
          type="button"
          [image]="siblingCategory?.thumbnail?.url"
          [imagePos]="positionEnum.left"
          [isRoundedImage]="false"
          [routerLink]="siblingCategory?.url"
          [isSecondary]="true"
          (click)="onClickSiblingCategory(siblingCategory)"
          [ngClass]="{ 'is-disabled': _selectedCategoryName === siblingCategory?.name }"
          [attr.disabled]="_selectedCategoryName === siblingCategory?.name ? true : null"
          data-testid="link"
        >
          {{siblingCategory?.name}}
        </a>
      </li>
    }
  </ul>
}